import { ProcessingOverlay } from '@components'

import { BorderRadius, Modal, ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../../../enums/modalId'
import { AccountFromTemplateModalActions } from '../../../AccountFromTemplateModalActions'
import { AccountFromTemplateModalHeading } from '../../../AccountFromTemplateModalHeading'
import { useCreateAccountFromTemplateForm } from '../../contexts'
import { CreateAccountFromTemplateConfirmationModal } from '../CreateAccountFromTemplateConfirmationModal'
import { CreateAccountFromTemplateForm } from '../CreateAccountFromTemplateForm'

export const CreateAccountFromTemplateModalComponent = (modalProps: ModalProps): ReactElement => {
  const { t } = useTranslation()
  const {
    accountNumberToConfirm,
    cancelConfirmation,
    closeModal,
    confirmCreate,
    isAwaitingConfirmation,
    isCreating,
    isProcessing,
    isSaveDisabled,
    submitForm,
  } = useCreateAccountFromTemplateForm()

  return (
    <>
      {!isAwaitingConfirmation && (
        <Modal {...modalProps} size="s">
          {isProcessing && <ProcessingOverlay borderRadius={BorderRadius.R16} />}
          <Modal.Header>
            <AccountFromTemplateModalHeading
              subtitle={t('coa.account_from_base_form.modal.create_subtitle')}
              title={t('add_account_modal.title_create')}
            />
          </Modal.Header>
          <Modal.Body>
            <CreateAccountFromTemplateForm />
          </Modal.Body>
          <Modal.Footer>
            <AccountFromTemplateModalActions
              isSaveButtonDisabled={isSaveDisabled}
              onClose={closeModal}
              onSubmit={submitForm}
              saveLabel={t('coa.account_from_base_form.create_button')}
            />
          </Modal.Footer>
        </Modal>
      )}
      <CreateAccountFromTemplateConfirmationModal
        accountNumber={accountNumberToConfirm}
        id={ModalId.AccountFromTemplateModalCreateConfirmation}
        isSubmitting={isCreating}
        onClose={cancelConfirmation}
        onOk={confirmCreate}
      />
    </>
  )
}
